module.exports = __webpack_public_path__ + "static/media/152-england.649840ac.svg";